import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Reciters from "../components/quraan/reciters";
import { baseUrl } from "../shared/baseUrl";

function Categoryreciters() {
  const [reciters, setreciters] = useState([]);
  const { categorySlug } = useParams();
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch(baseUrl + `api/v1/riwayat/${categorySlug}/reciters`)
      .then((res) => res.json())
      .then((data) => setreciters(Array.isArray(data) ? data : []))
      .catch(() => setreciters([]));
  }, [categorySlug]);

  const openreciter = (reciter) =>
    navigate(`/narration/${reciter.slug}/${categorySlug}`);

  // 🔍 SEARCH
  const filteredreciters = reciters.filter((reciter) =>
    reciter.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <div className="search-input">
        <input
          type="text"
          placeholder="Search reciters..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Reciters reciters={filteredreciters} onreciterClick={openreciter} />
    </>
  );
}

export default Categoryreciters;
